import analytics from './analytics.json'
import editors from './editors.json'
import misc from './misc.json'
import newsletters from './newsletters.json'
import patternLibrary from './patternLibrary.json'
import settings from './settings.json'
import shell from './shell.json'

// Each file holds top-level component namespaces; namespaces must be unique
// across files (enforced by a unit test in packages/functions).
const messages = { ...analytics, ...editors, ...misc, ...newsletters, ...patternLibrary, ...settings, ...shell }

export default messages
